<template>
  <div class="news-wrapper">
    <div class="">
      <div class="news-container row">
        <news-row
          v-if="!$md.mobile() || $md.tablet()"
          v-for="(news, index) in newsList"
          :key="index"
          :news="news"
          :buildingPage="true"
          class="news col-xs-12"
        ></news-row>
        <article-list-item        
          v-if="$md.mobile() && !$md.tablet()"
          v-for="(news, index) in newsList"
          :key="news.post_id"
          class="news-card"
          :article="news"
          :articlePage="false"
          :subTitleColor="'#BEBBAB'"
        ></article-list-item>
      </div>
      <div v-if="newsList && newsList.length" class="row">
        <div class="col-xs-offset-3 col-xs-6
                    col-sm-offset-4 col-sm-4 
                    col-md-offset-5 col-md-2">
          <more-button
            :name="$t('building_page.MORE_NEWS')"
            :backgroundColor="'#FFFFFF'"
            :borderColor="'#000000'"
            :textColor="'#000000'"
            :url="newsURL"
            class="more-btn">
          </more-button>
        </div>
      </div>
    </div>
    <div class="col-xs-12 no-news" v-if="!newsList.length">
      {{ $t('building_page.NO_NEWS') }}
    </div>
  </div>
</template>

<script>
  import article from '@/api/article';
  import MoreButton from '@/components/RoundButton';
  import NewsRow from '@/components/StockDetails/NewsRow';
  import ArticleListItem from '@/components/Article/ArticleListItem';

  export default {
    props: ['keyword', 'themeColor'],
    data() {
      return {
        maxNewsDisplay: 2,
        newsList: [],
      };
    },
    components: {
      MoreButton,
      NewsRow,
      ArticleListItem,
    },
    computed: {
      newsURL() {
        return `${window.SITE_URL}article/search?article_type=all&keyword=${this.keyword}`;
      },
    },
    mounted() {
      this.getNewsList();
    },
    watch: {
      keyword() {
        this.getNewsList();
      },
    },
    methods: {
      getNewsList() {
        const query = {
          articleType: 'all',
          ics: 'mr-ici',
          limit: `${this.maxNewsDisplay}`,
          page: 1,
          keyword: `${this.keyword}`,
        };
  
        article.getArticles({
          ...query,
        })
        .then((articles) => {
          this.newsList = articles;
        });
      },
    },
  };
</script>

<style scoped>
  .news-container {
    font-size: 19.25px;
  }
  
  .news {
    border-bottom: 1px solid #EAEAEA;
  }
  .date { 
    color: #a8a086;
    font-size: 14px;
  }
  .title {
    font-size: 20px;
    line-height: 25px;
  }

  .author {
    font-size: 12px;
  }

  .no-news {
    padding: 30px 0;
    text-align: center;
    font-size: 20px;
  }
  
  .more-btn {
    margin: 20px 0 0 0;
  }
  
  .news-card {
    font-size: 14px;
  }
</style>
